import { AuthState, Credentials, UpdatePassword } from "../../types/auth";
import { apiSlice } from "../../lib/baseQuery";

type UpdatePasswordRequest =  {
    userId: number;
    body: UpdatePassword ;
}

export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<AuthState, Credentials>({
            query: (credentials: Credentials) => ({
                url: "/api/auth/login",
                method: "POST",
                body: { ...credentials }
            })
        }),
        logout: builder.mutation({
            query: () => "/api/auth/logout"
        }),
        refreshToken: builder.query<AuthState, void>({
            query: () => ({
                url: "/api/auth/refresh-token",
                method: "GET",
            })
        }),
        changeUserPassword: builder.mutation<void, UpdatePasswordRequest>({
            query: (request: UpdatePasswordRequest) => ({
                url: `/api/user/${request.userId}/change-password`,
                method: "POST",
                body: request.body,
            })
        }),
    })
});

export const {
    useLoginMutation,
    useRefreshTokenQuery,
    useLogoutMutation,
    useChangeUserPasswordMutation,
} = authApi;